exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".border-rd[data-v-55243450] {\n  border: 2px solid #dfdfdf;\n  border-radius: 3px;\n}\n.border-lf[data-v-55243450] {\n  border-left: 2px solid #dfdfdf;\n  padding: 0px 10px;\n}\n.gap-1[data-v-55243450] {\n  gap: 10px;\n}\n", ""]);

// exports
